import LandingPage from "@/componets/LandingLayout";

const Cholestq10 = () => {
  return <LandingPage page={"cholestq10-LP-V2"} />;
};

Cholestq10.hideLayout = true;
export default Cholestq10;
